<template>
  <div id="all-page">
    <div id="app">
      <router-view :key="$route.fullPath" />
    </div>
    <div id="footer">
      <MainFooter />
    </div>
  </div>
</template>

<script>
import MainFooter from "@/components/MainFooter.vue";

export default {
  name: "App",
  components: {
    MainFooter,
  },
  methods: {
  },
  created: function () {},
};
</script>

<style lang="scss">
#all-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#app {
  flex: 1 0 auto;
}

#footer {
  flex-shrink: 0;
}

//asd
.bg-disabled {
  background: #e9ecef;
}
body {
  font-family: "Roboto", sans-serif;
  color: #343c6a;
}

.cursor-pointer {
  cursor: pointer;
}

ul {
  list-style-type: none;
}

.icons {
  position: relative;
  top: 6px;
}

.icon-chevron {
  position: relative;
  top: 7px;
}

.img-squared {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.border-8 {
  border-radius: 8px;
}
.bg-blue {
  background-color: #1a3d6b;
  color: #e7e6e6;
}
.text-blue {
  color: #1a3d6b;
}

.text-blue-2 {
  color: #295da7;
}

html,
body {
  height: 100%;
}
body {
  height: 100vh;
}

.bg-grey {
  background-color: #f7f8fa;
}

.bg-light-blue {
  background-color: #edf5fe;
}

.bg-light-red {
  background-color: #ffeae9;
}

$bg-treid: red;

.h-sm-auto {
  height: auto !important;
}

.bg-shadow {
  background-color: rgba($color: black, $alpha: 0.3);
}

@media (max-width: 1199px) {
  .border-md-bottom {
    border-bottom: 1px solid #dee2e6 !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .border-sm-bottom {
    border-bottom: 1px solid #dee2e6 !important;
  }
}
</style>
